import React from 'react';
import moment from 'moment';
import 'moment-duration-format';
import { TextMedium, TextMediumLarge } from 'lib/common/text';
import { Col, PaddedRow, Content } from '../../Tooltip/TooltipContent.styles';
import { DURATION_FORMAT, TIME_FORMAT, TIME_WITH_DATE_FORMAT } from '../../../common/constants';

export const PersonsOffshoreTooltipContent = ({ data }) => {
    const { name, beginDate, endDate, exitUnknown, beginEarly } = data;

    const beginTime = beginEarly
        ? moment(beginEarly).format(TIME_WITH_DATE_FORMAT)
        : moment(beginDate).format(TIME_FORMAT);
    const endTime = exitUnknown ? 'UNKNOWN' : moment(endDate).format(TIME_FORMAT);
    const duration = moment
        .duration(endDate - (beginEarly ? beginEarly : beginDate))
        .format(...DURATION_FORMAT);

    return (
        <Content>
            <PaddedRow>
                <Col>
                    <TextMediumLarge bold>{name}</TextMediumLarge>
                </Col>
                <Col>
                    <TextMedium>&nbsp;</TextMedium>
                </Col>
                <Col>
                    <TextMedium>&nbsp;</TextMedium>
                </Col>
            </PaddedRow>
            <PaddedRow>
                <Col>
                    <TextMedium caps color="gray2">
                        TIME ENTERED
                    </TextMedium>
                    <TextMedium>{beginTime}</TextMedium>
                </Col>
                <Col>
                    <TextMedium caps color="gray2">
                        TIME EXITED
                    </TextMedium>
                    <TextMedium>{endTime}</TextMedium>
                </Col>
                {!exitUnknown && (
                    <Col>
                        <TextMedium caps color="gray2">
                            DURATION
                        </TextMedium>
                        <TextMedium>{duration}</TextMedium>
                    </Col>
                )}
            </PaddedRow>
        </Content>
    );
};

PersonsOffshoreTooltipContent.displayName = 'PersonsOffshoreTooltipContent';

PersonsOffshoreTooltipContent.propTypes = {};

PersonsOffshoreTooltipContent.defaultProps = {};
